import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined'
import type { BaseStatusVariant } from '@/types/status.types'

export interface AlertIconProps {
  variant?: BaseStatusVariant
}

export function getAlertIcon(variant: AlertIconProps['variant']) {
  switch (variant) {
    case 'error':
      return CancelOutlinedIcon
    case 'warning':
      return ReportProblemOutlinedIcon
    case 'info':
      return InfoOutlinedIcon
    case 'success':
      return CheckCircleOutlineIcon
    default:
      return TextSnippetOutlinedIcon
  }
}

export function getAlertIconMarkupFormat(
  variant: BaseStatusVariant | undefined,
  color: string,
  fontSize: string = '20px'
) {
  const Icon = getAlertIcon(variant)

  return <Icon sx={{ fontSize, color }} />
}
